const STABILITY_FAMILY_CODES = new Set(['CST', 'MST', 'VST', 'HST', 'CCO', 'MCM', 'CSU']);

export default STABILITY_FAMILY_CODES;
